// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedPatients_root__11-Oj"};